<template>
  <div>
    <div class="avatar">
      <div class="shades"></div>
      <img class="bc" src="@img/mingshixiangqing_bg.png" >
      <div class="avatar-box">
        <div class="head">
          <img :src="teacher_img_url">
        </div>
        <div class="msg">
          <div class="msgDetail">
             <span class="teacherName">{{teacherName}}</span>
             <div
                :class="isFollow == 1? 'follow bg':'follow' "
                @click="follwTeacher(teacherId,collect)"
              >
                <span v-show="isFollow==0">
                  <img src="@img/guanzhu@2x.png" alt> 关注
                </span>
                <span v-show="isFollow==1">
                  <img src="@img/yiguanzhu@2x.png" alt> 已关注
                </span>
              </div>
          </div>
          <div class="brief">
            {{teacherBrief}}
          </div>
          <!-- <span>{{teacher.scope}}</span> -->
        </div>
      </div>
    </div>
    <div class="course">
      <a-row :gutter="24">
        <a-col :span="18">
          <div class="all-title">主讲课程</div>
          <div class="course-list">
            <div class="course-item">
              <a-row :gutter="22">
                <a-col
                  :span="23"
                  class="course-box"
                  v-for="item in courseList"
                  :key="item.id"
                  @click="toDetails(item.id,0)"
                >
                  <div class="card">
                    <CourseCards :item="item"/>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-col>
        <a-col :span="6" class="leftLine">
          <div class="teacher">
            <div class="all-title">推荐名师</div>
            <div class="teacher-list">
              <div class="teacher-item">
                <a-row :gutter="20">
                  <a-col :span="24">
                    <TeacherCard v-for="item in teacherList" :key="item.id" :item="item"></TeacherCard>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
  </div>
</template>
<script>
import { getCookie, group_sign } from '../../utils/tool'
import CourseCards from "./components/CourseCards";
import TeacherCard from "./components/TeacherCard";
import { mapState } from "vuex";
export default {
  name: "teacherDes",
  components: {
    CourseCards,
    TeacherCard
  },
  data() {
    return {
      teacher: {},
      courseList: [],
      isFollow: "",
      student_id:Number(getCookie('studentId')),
      account_id:Number(getCookie('account_id')),
      topId:Number(getCookie('top_category_id')),
      teacherBrief: '',
      teacher_img_url: '',
      teacherName: '',
      teacherId: '',
      collect: '',
      errmsg: "",
      errshow: false,
      teacherList: [],
    };
  },
  watch: {
    $route(){
      let id = this.$route.query.id
      this.getTeacherDes(id);
      this.getTeacherList();
    },
    // currentIndex() {
    //   // console.log("重新请求" + this.currentIndex + "的数据")
    //   this.showMyData(this.currentIndex)
    // }
  },
  computed: {
    ...mapState(["isLogin"])
  },
  methods: {
    getTeacherDes(id) {
      let that = this;
      var param = group_sign({account_id: that.account_id,student_id: that.student_id,teacher_id: id})
      this.$axios.post(this.$Api.apiGetTeacherById, param).then(
        res =>{
          that.teacherBrief = res.data.result.brief;
          that.teacher_img_url = res.data.result.img_url;
          that.teacherName = res.data.result.name;
          that.courseList = res.data.result.courseList;
          that.teacherId = res.data.result.id
          that.collect = res.data.result.is_collect;
          that.isFollow = that.collect == 0 ? 0 : 1
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");})
    },
    toDetails(id, type) {
      if (this.isLogin) {
        this.$router.push({
        path: "/page/course_details",
        query: { course_id: id, course_type: type }
      });
      } else {
        this.$root.Bus.$emit("showLogin")
      }
    },
    follwTeacher(id, follow) {
      let that = this;
      if (that.isLogin) {
        if (follow == 0) {
          var param = group_sign({account_id: that.account_id,student_id: that.student_id,teacher_id: id,collect_state: 1})
          this.$axios.post(this.$Api.apiGetCollectTeacher, param).then(
            res => {
              if (res.data.errcode == 0) {
                that.getTeacherDes(id);
              } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  that.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              } else {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  this.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
              }
              
            }
          ).catch(error => {console.log(error, ">>>>>>>>>");})
        } else if (follow == 1) {
          var params = group_sign({account_id: that.account_id,student_id: that.student_id,teacher_id: id,collect_state: 0})
          this.$axios.post(this.$Api.apiGetCollectTeacher, params).then(
            res => {
              if (res.data.errcode == 0) {
                that.getTeacherDes(id);
              } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  that.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              } else {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
              }
            }
          ).catch(error => {console.log(error, ">>>>>>>>>");})
        }
      } else {
        this.$root.Bus.$emit("showLogin")
      }
      
    },
    // 查询名师列表
    getTeacherList() {
      let that = this;
      var param = group_sign({account_id: that.account_id,top_category_id: that.topId,number:9999})
      this.$axios.post(this.$Api.apiGetTeacherList,param).then(
        res => {
          that.teacherList = res.data.result
          for(let i in that.teacherList){
            if(that.teacherList[i].id == that.$route.query.id) {
              that.teacherList.splice(i,1)
            }
          }
          that.teacherList = that.makeRandomArr(that.teacherList, 3)
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");})
    },
    makeRandomArr(arrList,num){
      if(num>arrList.length){
        return;
      }
  //    var tempArr=arrList.concat();    
      var tempArr=arrList.slice(0);
      var newArrList=[];    
      for(var i=0;i<num;i++){
          var random=Math.floor(Math.random()*(tempArr.length-1));
          var arr=tempArr[random];
          tempArr.splice(random, 1);
          newArrList.push(arr);    
      }
      return newArrList;
    }
  },
  beforeMount() {
    let id = this.$route.query.id;
    this.getTeacherDes(id);
    this.getTeacherList();
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/teacherDetail.less');
</style>
